import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { STORE } from "../config/store";
import "../css/paysuccess.css";

const states = {
  success: {
    icon: "✓",
    title: "Payment page completed",
    copy: "The hosted screen has sent this browser back. That navigation alone cannot confirm settlement; fulfilment waits for an independent match against the provider's payment confirmation.",
  },
  cancel: {
    icon: "↩",
    title: "Payment was not completed",
    copy: "The payment screen closed without a completed result. Nothing was removed from the cart; check its contents before making another attempt.",
  },
  failed: {
    icon: "!",
    title: "Payment status unavailable",
    copy: "We could not determine a completed checkout from this return. Do not retry repeatedly if your bank shows a pending charge; contact customer service with your order reference.",
  },
};

function PaymentResult() {
  const [params] = useSearchParams();
  const state = params.get("state");
  const content = states[state] || states.failed;

  return (
    <main className={`payment-result payment-${states[state] ? state : "failed"}`}>
      <div className="payment-result-card">
        <div className="payment-result-icon" aria-hidden="true">{content.icon}</div>
        <h1>{content.title}</h1>
        <p>{content.copy}</p>
        <p className="payment-support">Support: <a href={`mailto:${STORE.supportEmail}`}>{STORE.supportEmail}</a></p>
        <div className="payment-actions">
          <Link to="/cartpage">View cart</Link>
          <Link to="/shop">Continue shopping</Link>
        </div>
      </div>
    </main>
  );
}

export default PaymentResult;
